import { Record } from 'immutable';
import { LocaleService } from '@sm360/widget-commons-core-services';

const TransmissionRecord = Record({
    selectionCode: '',
    code: '',
    typeCode: '',
    rank: 0,
    type: 0,
    speeds: 0,
    isCVT: false,
    description: '',
});

class Transmission extends TransmissionRecord {
    getSelectionCode() {
        return this.get('selectionCode');
    }

    getTypeAndSpeeds() {
        const speed = LocaleService.t('transmission.speeds', { speeds: this.get('speeds') });
        const types = LocaleService.t('transmission.types', { type: this.get('description') });
        return this.get('isCVT')
            ? LocaleService.t('transmission.cvt', { type: this.get('description') })
            : `${types} <span class='speed'>${speed}</span>`;
    }

    getTransmission() {
        const speed = LocaleService.t('transmission.speeds', { speeds: this.get('speeds') });
        const types = LocaleService.t('transmission.types', { type: this.get('description') });
        return this.get('isCVT')
            ? LocaleService.t('transmission.cvt', { type: this.get('description') })
            : `${types} ${speed}`;
    }
}

export default Transmission;



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/ModelYear/models/TransmissionModel.js